import { render, staticRenderFns } from "./DetailSample.vue?vue&type=template&id=78548fc2&scoped=true"
import script from "./DetailSample.vue?vue&type=script&lang=js"
export * from "./DetailSample.vue?vue&type=script&lang=js"
import style0 from "./DetailSample.vue?vue&type=style&index=0&id=78548fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78548fc2",
  null
  
)

export default component.exports